var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataLabel',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.stateClassName,attrs:{"item":"","title":_vm.state.name}},[_vm._t("default"),_vm._v(" "),(_vm.showLabel)?_c('small',[_vm._v(_vm._s(_vm.state.name))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }